import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import ProductImage from '../components/ProductImage';
import API_BASE_URL from '../config/apiConfig';
import { deriveRatingWidth } from '../utils/productRating';



const ProductSubCategoryList = () => {
  const { slug } = useParams();
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const searchParams = new URLSearchParams(location.search);
  const titleFromQuery = searchParams.get('name');
  const subCategorySlug = searchParams.get('subCategorySlug');
  const categorySlug = searchParams.get('categorySlug');
  const title = titleFromQuery || (slug ? slug.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()) : 'Products');

  useEffect(() => {
    const fetchProducts = async () => {
      setIsLoading(true);
      try {
        const params = new URLSearchParams();
        if (subCategorySlug) {
          params.append('SubCategorySlug', subCategorySlug);
        } else if (slug) {
          params.append('SubCategorySlug', slug);
        }
        if (categorySlug) {
          params.append('CategorySlug', categorySlug);
        }

        const response = await fetch(`${API_BASE_URL}/product/list?${params.toString()}`);
        const result = await response.json();
        if (response.ok && result?.success && Array.isArray(result.data)) {
          setProducts(result.data);
        } else {
          setProducts([]);
        }
      } catch (error) {
        setProducts([]);
        console.error('Failed to load sub category products:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, [slug, subCategorySlug, categorySlug]);

  return (
    <main className="main">
      <div className="page-header mt-10 mb-50">
        <div className="container">
          <div className="archive-header">
            <div className="row align-items-center">
              <div className="col-xl-12">
                <h1 className="mb-0 text-uppercase">{title}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mb-10">
        <div className="row">
          <div className="col-12">
            {isLoading ? (
              <div className="text-center py-5">Loading products...</div>
            ) : products.length === 0 ? (
              <div className="text-center py-5">
                <h5 className="mb-0">No products to display.</h5>
              </div>
            ) : (
              <div className="row product-grid">
                {products.map((product) => (
                  <div key={product.ProductId || product.ProductName} className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                    <div className="product-cart-wrap mb-30">
                      <div className="product-img-action-wrap">
                        <div className="product-img product-img-zoom">
                          <Link to={`/product-detail/${product.ProductId || 1}`}>
                            <ProductImage className="default-img" src={product.DefaultImage} alt={product.ProductName} />
                            <ProductImage className="hover-img" src={product.HoverImage || product.DefaultImage} alt={product.ProductName} />
                          </Link>
                        </div>

                        {product.BadgeLabel ? (
                          <div className="product-badges product-badges-position product-badges-mrg">
                            <span className={product.BadgeClass || 'hot'}>{product.BadgeLabel}</span>
                          </div>
                        ) : null}
                      </div>

                      <div className="product-content-wrap">
                        <div className="product-category">
                          <Link to="#">{product.SubCategoryName || 'Category'}</Link>
                        </div>
                        <h2><Link to={`/product-detail/${product.ProductId || 1}`}>{product.ProductName}</Link></h2>
                        <div className="product-rate-cover">
                          <div className="product-rate d-inline-block">
                            <div className="product-rating" style={{ width: deriveRatingWidth(product.Rating) }}></div>
                          </div>
                          <span className="font-small ml-5 text-muted"> ({product.Rating || 0})</span>
                        </div>

                        <div className="product-card-bottom">
                          <div className="product-price">
                            <span><i className="fa fa-inr fs-10" aria-hidden="true"></i>{Number(product.Price)}</span>
                            <span className="old-price"><i className="fa fa-inr fs-10" aria-hidden="true"></i>{Number(product.OldPrice)}</span>
                          </div>
                          <div className="add-cart">
                            <Link className="add" to="/shop-cart"><i className="fi-rs-shopping-cart mr-5"></i>Buy Now </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default ProductSubCategoryList;